<template>
  <div>
    <public-header showBack :title="title"></public-header>
    <div style="background:#fff;border-radius: 12px;">
      <a-spin :spinning="spinning">
        <Layout
          v-if="userData"
          :showMenu="true"
          :menuList="menuList"
          :defaultKeys="defaultKeys"
          :activeKey.sync="key"
          :mainImage="false"
        >
          <template slot="content">
            <!-- 基本信息 -->
            <div class="full-width full-height" style="color:#363B45" v-if="key === 0">
              <!-- 基本信息 -->
              <div class="font-14 p-b-24" style="font-weight: 700;">基本信息</div>
              <a-row class="full-width" :gutter="[24,24]">
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">战区：</div>
                    <div style="flex-grow: 1">{{userData.warZone.name}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">大区：</div>
                    <div style="flex-grow: 1">{{userData.regional.name}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">所属地区：</div>
                    <div style="flex-grow: 1">{{$tkRegions.getFullName(userData.region)}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">代理商：</div>
                    <div style="flex-grow: 1">{{userData.nickName}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">手机号：</div>
                    <div style="flex-grow: 1">{{userData.phone}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">门店数：</div>
                    <div style="flex-grow: 1">{{storeNum}}</div>
                  </tk-flex>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                  <tk-flex class="full-wdith">
                    <div style="width:90px;text-align: right;flex-shrink: 0;">库存数：</div>
                    <div style="flex-grow: 1">{{stockNum}}</div>
                  </tk-flex>
                </a-col>

              </a-row>
            </div>
            <!-- 仓库库存 -->
            <div class="full-width full-height" style="color:#363B45" v-if="key === 1">
              <div class="font-14 p-b-24" style="font-weight: 700;">仓库库存</div>
              <div class="font-14 p-b-24">库存总数：{{stockNum}}</div>
              <ak-model-table model="warehouseStock" :filters="filters" :perPage="20" tableSize="small" />
            </div>
          </template>
        </Layout>
        <div v-else style="width: 100%; height: 100vh;border-radius: 12px;"></div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
import Layout from '../components/layout.vue'
export default {
  components: {
    publicHeader,
    Layout
  },
  data () {
    return {
      title: '',
      filters: {
        isDelete: false
      },
      userData: null,
      spinning: true,
      menuList: [
        {
          name: '基本信息'
        },
        {
          name: '仓库库存'
        }
      ],
      defaultKeys: [0],
      key: 0,
      storeNum: 0,
      stockNum: 0,
      totalNum: 0
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      let id = this.$route.query.id
      this.filters.agent = id
      let { data: user } = await this.$tkParse.get(`/classes/_User/${id}`, {
        params: {
          include: 'warZone,regional'
        }
      })
      this.title = user.nickName
      await this.getNum()
      this.userData = user
      this.spinning = false
    },
    // 获取统计数量
    async getNum () {
      // 获取库存数量
      let { data: stockNum } = await this.$tkParse.get(`/aggregate/warehouseStock`, {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: '$num'
            }
          },
          match: {
            isDelete: false,
            agent: this.$route.query.id
          }
        }
      })
      this.stockNum = stockNum.results && stockNum.results.length ? stockNum.results[0].total || 0 : 0
      // 获取门店数量
      let { data: res } = await this.$tkParse.get(`/aggregate/store`, {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: 1
            }
          },
          match: {
            isDelete: false,
            agent: this.$route.query.id
          }
        }
      })
      // console.log(res)
      this.storeNum = res.results && res.results.length ? res.results[0].total || 0 : 0
    }
  }
}
</script>
